module.exports = __webpack_public_path__ + "img/menupro.35980b24.png";